import React from 'react';
import VstComponent from './VstComponent';
import PropTypes from 'prop-types';
import { css } from 'glamor';
import addClassName from '../utils/add-class-name';
import classNames from 'classnames';
import copyProps from '../utils/copy-props';
import namespaceOptions from '../utils/namespace-options';

export default class VstToggleButton extends VstComponent {
  constructor(props) {
    super(props);
    this._toggleButton = this._toggleButton.bind(this);
  }

  _toggleButton(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }
    this.props.onToggle(e);
  }

  _getCSS() {
    return {
      '&.on': {
        backgroundColor: this._theme(7)
      }
    };
  }

  render() {
    const { disabled, on, onText, offText } = this.props;
    const classes = 'boolean-toggle no-highlight';
    const rule = css(this._getCSS());

    let props = addClassName(
      this.props,
      classNames(
        namespaceOptions('vst', this.props.options),
        classes,
        { disabled },
        { on },
        { neutral: on },
        rule.toString()
      )
    );

    props = copyProps(props, [
      'options',
      'on',
      'onToggle',
      'neutral',
      'offText',
      'onText'
    ]);
    return (
      <button aria-pressed={on} onClick={this._toggleButton} {...props}>
        <div className="toggle-dot" />
        <span className="toggle-text">
          <span aria-hidden={!on}>{onText}</span>
          <span aria-hidden={on}>{offText}</span>
        </span>
      </button>
    );
  }
}

VstToggleButton.propTypes = {
  on: PropTypes.bool,
  neutral: PropTypes.bool,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func,
  offText: PropTypes.string,
  onText: PropTypes.string,
  'aria-describedby': PropTypes.string,
  'aria-label': PropTypes.string,
  style: PropTypes.object
};

VstToggleButton.defaultProps = {
  on: false,
  neutral: false,
  onToggle: () => {},
  disabled: false,
  offText: '',
  onText: '',
  'aria-describedby': '',
  'aria-label': '',
  style: {}
};
